import { connect } from 'react-redux';
import React from 'react';
import { Controls, validators } from 'shared/helper/form';
import { findInstitutionsBy } from '../actions';

// import InstitutionOption from './InstitutionOption';

var AsyncSelect = Controls.AsyncSelect,
  Select = Controls.Select;
var notEmpty = validators.notEmpty;
var INSTITUTION_MAX_LENGTH = 128;
export var defaultValues = {
  institution: null,
  type: null,
  position: null
};
var InstitutionForm = function InstitutionForm(_ref) {
  var displayInstitutionType = _ref.displayInstitutionType,
    findInstitutionsBy = _ref.findInstitutionsBy,
    _ref$formStyles = _ref.formStyles,
    formStyles = _ref$formStyles === void 0 ? {
      wrapper: 'mb-3'
    } : _ref$formStyles,
    institutionInfoMandatory = _ref.institutionInfoMandatory,
    institutionTypes = _ref.institutionTypes,
    positions = _ref.positions;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AsyncSelect, {
    allowsNewSelection: true,
    asyncCallback: function asyncCallback(input) {
      return findInstitutionsBy('name', input);
    },
    className: "form-control dropdown",
    isClearable: true,
    isValidNewOption: function isValidNewOption(input) {
      return input.label && input.label.length <= INSTITUTION_MAX_LENGTH;
    },
    label: "Institution/Company",
    messages: {
      notEmpty: "Value is required and can't be empty"
    },
    minLength: 3,
    name: "institution[institution]"
    // TODO (from customer-9619) this optionComponent prop goes nowhere. Do we need to pass the optionComponent prop to CommonSelect in AsyncSelect ?
    // If yes, we need to fix the InstitutionOption component and scss just like we did the FapiaoTypeOption
    // optionComponent={InstitutionOption}
    ,
    placeholder: "Select an institution",
    noOptionsMessage: "Start Typing to choose an institution",
    styles: formStyles,
    validators: institutionInfoMandatory ? {
      notEmpty: notEmpty
    } : {}
  }), displayInstitutionType ? /*#__PURE__*/React.createElement(Select, {
    isClearable: true,
    label: "Type of organization",
    name: "institution[type]",
    styles: formStyles,
    options: institutionTypes,
    sort: true
  }) : null, /*#__PURE__*/React.createElement(Select, {
    isClearable: true,
    label: "Position",
    messages: {
      notEmpty: "Value is required and can't be empty"
    },
    name: "institution[position]",
    styles: formStyles,
    options: positions,
    sort: true,
    validators: institutionInfoMandatory ? {
      notEmpty: notEmpty
    } : {}
  }));
};
var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
  var account = _ref2.account;
  var displayInstitutionType = _ref3.displayInstitutionType;
  return {
    displayInstitutionType: displayInstitutionType,
    institutionTypes: account.institutionTypes,
    positions: account.positions
  };
};
export default connect(mapStateToProps, {
  findInstitutionsBy: findInstitutionsBy
})(InstitutionForm);